import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import CardActionArea from '@material-ui/core/CardActionArea';

import { colors } from 'styles/theme';

const promoActionAreaCss = css`
  &.MuiCardActionArea-root:hover {
    color: ${colors.darkPurple};

    /* Cancel hover effect */
    .MuiCardActionArea-focusHighlight {
      opacity: 0;
    }
  }
`;

function PromoActionArea({ children, className }) {
  return (
    <CardActionArea
      className={className}
      css={promoActionAreaCss}
      tabIndex={-1}
    >
      {children}
    </CardActionArea>
  );
}

PromoActionArea.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default PromoActionArea;
